import Logger from '../lib/logger';
import event, { type EventEmitter } from '../lib/mixins/event';

/** Object.assign below grafts the event mixin onto the prototype at runtime. */
interface SidebarModal extends EventEmitter {}

class SidebarModal {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	NAME: string;
	dom: HTMLElement;
	sidebarModalId?: string;
	closeButton: HTMLElement | null;
	domActiveClass: string;

	/**
	 * Class constructor
	 */
	constructor(dom: HTMLElement) {

		this.NAME = 'SidebarModal';

		this.dom = dom;
		this.sidebarModalId = this.dom.dataset.sidebarModal;
		this.closeButton = this.dom.querySelector<HTMLElement>('[data-sidebar-modal-close]');
		this.domActiveClass = 'sidebar-modal--active';
	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);

		// Both events name a modal, so each instance answers only for itself. Comparing the
		// element's own attribute to the field read from it would always match, opening every
		// modal on the page.
		document.addEventListener('sidebar-modal:open', (e) => {
			if (e.detail?.sidebarModalId === this.sidebarModalId) {
				this.open();
			}
		});

		document.addEventListener('sidebar-modal:close', (e) => {
			if (e.detail?.sidebarModalId === this.sidebarModalId) {
				this.close();
			}
		});

		// Listen for clicks on the close button
		this.closeButton?.addEventListener('click', (e) => {
			e.preventDefault();
			document.dispatchEvent(new CustomEvent('sidebar-modal:close', { detail: { sidebarModalId: this.sidebarModalId } }));
		});

		// If close on anything outside of .sidebar-modal__modal, close the modal
		this.dom.addEventListener('click', (e) => {
			if (e.target instanceof Element && !e.target.closest('.sidebar-modal__modal')) {
				document.dispatchEvent(new CustomEvent('sidebar-modal:close', { detail: { sidebarModalId: this.sidebarModalId } }));
			}
		});
	}

	/**
	 * open - Open the sidebar modal
	 */
	open() {
		this.dom.classList.add(this.domActiveClass);
	}

	/**
	 * close - Close the sidebar modal
	 */
	close() {
		this.dom.classList.remove(this.domActiveClass);
	}
}

Object.assign(SidebarModal.prototype, event);

export default SidebarModal;
